import { createSlice } from '@reduxjs/toolkit';
const availableLanguages = ['en', 'pl'];
const language = localStorage.getItem('language') || navigator.language.split('-')[0] || 'en';
export const initialState = {
    language: availableLanguages.includes(language) ? language : 'en'
};
const slice = createSlice({
    name: 'language',
    initialState: initialState,
    reducers: {
        setLanguage: (state, action) => {
            try {
                localStorage.setItem('language', action.payload);
                state.language = action.payload;
            }
            catch (_a) { }
        }
    }
});
export const { setLanguage } = slice.actions;
export default slice.reducer;
